<template>
  <div class="order-result-wrap">
      <img src="@/assets/img/icon_success.png" class="success-img"/>
      <div class="text title">下单成功</div>
      <div class="text">请耐心等待，师傅将火速前往</div>
      <div class="btn-wrap">
        <div class="view-btn" @click="viewOrder">查看订单</div>
      </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
  async mounted() {

  },
  methods: {
    viewOrder() {
      this.$router.push('viewOrder')
    }
  }
};
</script>

<style lang="scss">
.order-result-wrap {
  .success-img {
    margin: 54px auto 0;
    width: 90px;
    display: block;
  }
  .text {
    font-size: 16px;
    color: #969696;
    text-align: center;

    &.title {
      font-size: 20px;
      color: #3399FF;
      margin-bottom: 7px;
      margin-top: 21px;
    }
  }

  .btn-wrap {
    padding-top: 86px;
    display: flex;
    align-items: center;
    justify-content: center;

    .view-btn {
      border: 1px solid #3399FF;
      border-radius: 23px;
      border-radius: 23px;
      width: 285px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 16px;
      color: #3399FF;
    }
  }
}
</style>
